export default {
    sim_provider_account_create_title: "Create SIM Provider Account",
    sim_provider_account_same_name_exits: "A SIM Provider Account with same name exists already",
    sim_provider_account_create_success_message: "The SIM Provider Account has been created",
    sim_provider_account_edit_title: "Edit SIM Provider Account",
    sim_provider_account_edit_success_message: "The SIM Provider Account has been edited",
    sim_provider_account_name: "Account Name",

    sim_provider_account_sim_provider: "SIM Provider",
    sim_provider_account_sim_type: "SIM Type",
    sim_provider_account_username: "Username",
    sim_provider_account_password: "Password",
}